import {inject, Injectable, signal, WritableSignal} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {LoginCredentials} from '../../interfaces/LoginCredentials.interface';
import {catchError, map, Observable} from 'rxjs';
import {LoginResponse} from '../../interfaces/LoginResponse.interface';
import {Admin} from '../../interfaces/Admin.interface';
import {ToastrService} from 'ngx-toastr';
import {Router} from '@angular/router';
import {ACCESS_TOKEN, API_URLS, APP_URLS, CURRENT_USER} from '../../../../shared/utils/constants';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private readonly _http: HttpClient = inject(HttpClient);
  private readonly _router: Router = inject(Router);
  private readonly _toastrService: ToastrService = inject(ToastrService);

  currentUser: WritableSignal<Admin> = signal(JSON.parse(localStorage.getItem(CURRENT_USER)!));
  accessToken: WritableSignal<string> = signal(localStorage.getItem(ACCESS_TOKEN)!);
  isLoading: WritableSignal<boolean> = signal(false);

  /**
   * Login a User
   * @param loginCredentials - The login credentials of the user
   */
  login(loginCredentials: LoginCredentials): Observable<void> {
    this.isLoading.set(true);
    return this._http.post<LoginResponse>(API_URLS.AUTH.LOGIN, loginCredentials)
      .pipe(
        map((loginResponse: LoginResponse) => {
          this.isLoading.set(false);
          this.currentUser.set(loginResponse.user);
          this.accessToken.set(loginResponse.token);
          localStorage.setItem(CURRENT_USER, JSON.stringify(loginResponse.user));
          localStorage.setItem(ACCESS_TOKEN, loginResponse.token);
          this._toastrService.success(`Welcome ${this.currentUser().username}`, 'Login Successfully');
          this._router.navigate([APP_URLS.DASHBOARD.BASE]).then();
        }),

        catchError((err: HttpErrorResponse) => {
          this.isLoading.set(false);
          this._toastrService.error(err.error || err.error.message(), 'Authentication Failed');
          this.logout();
          throw err;
        }),
      );
  }

  /**
   * Logout a User
   */
  logout(): void {
    this.currentUser.set({} as Admin);
    this.accessToken.set('');
    localStorage.removeItem(CURRENT_USER);
    localStorage.removeItem(ACCESS_TOKEN);
    this._router.navigate([APP_URLS.LOGIN]).then();
  }

}
